var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopHalfTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 691,
    height: 257,
    viewBox: "0 0 691 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 74,
    width: 341,
    height: 183,
    rx: 25,
    fill: "#5E3B11"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 143,
    width: 38,
    height: 105,
    rx: 10,
    transform: "rotate(-90 435 143)",
    fill: "#5E3B11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 38,
    width: 38,
    height: 138,
    rx: 10,
    transform: "rotate(-90 502 38)",
    fill: "#5E3B11"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 502,
    width: 38,
    height: 143,
    rx: 10,
    fill: "#5E3B11"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 15,
    width: 38,
    height: 120,
    rx: 10,
    fill: "#5E3B11"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 53,
    width: 38,
    height: 120,
    rx: 10,
    transform: "rotate(-90 0 53)",
    fill: "#5E3B11"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 105,
    width: 38,
    height: 179,
    rx: 10,
    transform: "rotate(-90 512 105)",
    fill: "#5E3B11"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 86,
    width: 30,
    height: 138,
    rx: 10,
    fill: "#35220A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 128,
    width: 30,
    height: 115,
    rx: 10,
    fill: "#35220A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 86,
    width: 30,
    height: 25,
    rx: 10,
    fill: "#35220A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 98,
    width: 30,
    height: 106,
    rx: 10,
    fill: "#35220A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHalfTree);
export default __webpack_public_path__ + "static/media/TopHalfTree.3b42ad8138d606caea518eac4947a974.svg";
export { ForwardRef as ReactComponent };